import React from 'react';
import SectionTitle from '../ui/SectionTitle';
import Card, { CardContent } from '../ui/Card';
import './WhyUsContent.css';

const WhyUsContent = () => {
    const strengths = [{
            title: 'Experienced Specialists',
            description: 'Skilled communication professionals with proven track records.'
        },
        {
            title: 'Ethical & Compliant',
            description: 'Following industry standards and legal guidelines.'
        },
        {
            title: 'Cost-Effective Solutions',
            description: 'Outsourcing that reduces operational overhead.'
        },
        {
            title: 'Professional Infrastructure',
            description: 'State-of-the-art call center technology and systems.'
        },
        {
            title: 'High Recovery Rates',
            description: 'Data-driven recovery strategies for maximum results.'
        },
        {
            title: 'Customized Services',
            description: 'Scalable operations tailored to each client.'
        }
    ];

    return ( <
        section className = "why-us-section" >
        <
        div className = "container" >
        <
        SectionTitle subtitle = "WHY US"
        title = "Why Choose Dynamic Enterprises" / >

        <
        div className = "why-us-description" >
        <
        p >
        Our services are designed to help organizations reduce operational costs,
        improve customer engagement, and maximize recovery
        while maintaining positive relationships with customers. <
        /p> <
        /div>

        <
        div className = "strengths-grid" > {
            strengths.map((strength, index) => ( <
                Card key = { index } >
                <
                CardContent >
                <
                h3 > { strength.title } < /h3> <
                p > { strength.description } < /p> <
                /CardContent> <
                /Card>
            ))
        } <
        /div>

        <
        div className = "compliance-section" >
        <
        h3 > Commitment to Compliance < /h3> <
        p >
        Dynamic Enterprises follows industry standards and legal guidelines to ensure ethical communication and responsible debt recovery practices
        while protecting customer rights and confidentiality. <
        /p> <
        /div> <
        /div> <
        /section>
    );
};

export default WhyUsContent;